import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "center-wrapper" }
const _hoisted_2 = { class: "input-block" }
const _hoisted_3 = ["readonly"]
const _hoisted_4 = {
  class: "inline-or-block",
  style: {"padding-left":"4px"}
}
const _hoisted_5 = ["disabled"]
const _hoisted_6 = {
  key: 0,
  class: "invalid-text",
  style: {"text-align":"left","padding":"2px 2px 2px 120px"}
}
const _hoisted_7 = { class: "input-block" }
const _hoisted_8 = { class: "input-block" }
const _hoisted_9 = { class: "input-block" }
const _hoisted_10 = {
  key: 0,
  class: "invalid-text",
  style: {"padding":"2px 2px 2px 160px"}
}
const _hoisted_11 = { class: "noshigami-input-wrap" }
const _hoisted_12 = { class: "noshigami-input-block" }
const _hoisted_13 = { class: "noshigami-input-block" }
const _hoisted_14 = { class: "input-block" }
const _hoisted_15 = { style: {"display":"inline-block"} }
const _hoisted_16 = { key: 0 }
const _hoisted_17 = { style: {"word-break":"break-all"} }
const _hoisted_18 = { style: {"word-break":"break-all"} }
const _hoisted_19 = ["onUpdate:modelValue"]
const _hoisted_20 = ["onUpdate:modelValue"]
const _hoisted_21 = {
  key: 0,
  class: "invalid-text",
  style: {"text-align":"center","padding":"2px"}
}
const _hoisted_22 = { style: {"text-align":"center","padding-top":"20px"} }
const _hoisted_23 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loading = _resolveComponent("loading")!
  const _component_JapaneseInput = _resolveComponent("JapaneseInput")!
  const _component_select_noshigami = _resolveComponent("select-noshigami")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _cache[9] || (_cache[9] = _createElementVNode("label", { class: "block-label" }, "顧客コード", -1)),
        _withDirectives(_createElementVNode("input", {
          class: "form-control no-ime",
          type: "tel",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.newOrder.customerId) = $event)),
          onBlur: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.searchCustomer && _ctx.searchCustomer(...args))),
          readonly: !_ctx.isInsert
        }, null, 40, _hoisted_3), [
          [_vModelText, _ctx.newOrder.customerId]
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("button", {
            class: "btn-primary",
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.showDialog && _ctx.showDialog(...args))),
            disabled: !_ctx.isInsert
          }, "検索", 8, _hoisted_5),
          _createVNode(_component_loading, {
            style: {"display":"inline-block","padding-left":"10px"},
            imgHeight: "25px",
            imgWidth: "25px",
            initialLoad: false,
            ref: "loading"
          }, null, 512)
        ])
      ]),
      (_ctx.customerNotFound)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, "対応する顧客が見つかりませんでした"))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_7, [
        _cache[10] || (_cache[10] = _createElementVNode("label", { class: "block-label" }, "顧客名", -1)),
        _createVNode(_component_JapaneseInput, {
          modelValue: _ctx.newOrder.customerName,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.newOrder.customerName) = $event)),
          tabindex: "-1",
          readonly: ""
        }, null, 8, ["modelValue"])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _cache[11] || (_cache[11] = _createElementVNode("label", { class: "block-label" }, "顧客名カナ", -1)),
        _createVNode(_component_JapaneseInput, {
          modelValue: _ctx.newOrder.customerKana,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.newOrder.customerKana) = $event)),
          tabindex: "-1",
          readonly: ""
        }, null, 8, ["modelValue"])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _cache[12] || (_cache[12] = _createElementVNode("label", { class: "block-label" }, "注文日", -1)),
        _withDirectives(_createElementVNode("input", {
          class: "form-control",
          type: "date",
          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.newOrder.orderDate) = $event))
        }, null, 512), [
          [_vModelText, _ctx.newOrder.orderDate]
        ]),
        (!_ctx.$root.util.isValidDate(_ctx.newOrder.orderDate))
          ? (_openBlock(), _createElementBlock("div", _hoisted_10, "有効な日付ではありません"))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("div", _hoisted_12, [
          _cache[13] || (_cache[13] = _createElementVNode("label", { class: "block-label" }, "のし紙：表書", -1)),
          _createVNode(_component_select_noshigami, {
            noshigami: _ctx.newOrder.noshigamiId,
            "onUpdate:noshigami": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.newOrder.noshigamiId) = $event))
          }, null, 8, ["noshigami"])
        ]),
        _createElementVNode("div", _hoisted_13, [
          _cache[14] || (_cache[14] = _createElementVNode("label", { class: "block-label" }, "のし紙：なまえ", -1)),
          _createVNode(_component_JapaneseInput, {
            modelValue: _ctx.newOrder.noshigamiName,
            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.newOrder.noshigamiName) = $event))
          }, null, 8, ["modelValue"])
        ])
      ]),
      _createElementVNode("div", _hoisted_14, [
        _cache[17] || (_cache[17] = _createElementVNode("div", null, [
          _createElementVNode("label", {
            class: "block-label",
            style: {"vertical-align":"top"}
          }, "送り先")
        ], -1)),
        _createElementVNode("div", null, [
          _createElementVNode("table", _hoisted_15, [
            _cache[16] || (_cache[16] = _createElementVNode("thead", null, [
              _createElementVNode("tr", { class: "table-header" }, [
                _createElementVNode("th", null, "顧客名"),
                _createElementVNode("th", null, [
                  _createTextVNode("顧客名"),
                  _createElementVNode("br"),
                  _createTextVNode("カナ")
                ]),
                _createElementVNode("th", null, "郵便番号"),
                _createElementVNode("th", null, "住所"),
                _createElementVNode("th", null, "電話番号"),
                _createElementVNode("th", null, "品名記号"),
                _createElementVNode("th", null, "発送日"),
                _createElementVNode("th", null, "備考")
              ])
            ], -1)),
            _createElementVNode("tbody", null, [
              (!_ctx.newOrder.destination || _ctx.newOrder.destination.length === 0)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_16, [...(_cache[15] || (_cache[15] = [
                    _createElementVNode("td", {
                      colspan: "10",
                      class: "no-data"
                    }, " データがありません ", -1)
                  ]))]))
                : _createCommentVNode("", true),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.newOrder.destination, (dest) => {
                return (_openBlock(), _createElementBlock("tr", {
                  class: "stripe-tr",
                  key: dest.id
                }, [
                  _createElementVNode("td", null, _toDisplayString(dest.customerName), 1),
                  _createElementVNode("td", null, _toDisplayString(dest.customerKana), 1),
                  _createElementVNode("td", _hoisted_17, _toDisplayString(dest.customerZipCode), 1),
                  _createElementVNode("td", null, _toDisplayString(_ctx.$root.util.getOrderDestAddress(dest)), 1),
                  _createElementVNode("td", _hoisted_18, _toDisplayString(dest.customerPhoneNo), 1),
                  _createElementVNode("td", null, [
                    _withDirectives(_createElementVNode("input", {
                      class: "form-control input-productCode",
                      type: "tel",
                      "onUpdate:modelValue": ($event: any) => ((dest.productCode) = $event)
                    }, null, 8, _hoisted_19), [
                      [_vModelText, dest.productCode]
                    ])
                  ]),
                  _createElementVNode("td", null, [
                    _withDirectives(_createElementVNode("input", {
                      class: "form-control input-sendDate",
                      type: "date",
                      "onUpdate:modelValue": ($event: any) => ((dest.sendDate) = $event)
                    }, null, 8, _hoisted_20), [
                      [_vModelText, dest.sendDate]
                    ]),
                    (!_ctx.$root.util.isValidDate(dest.sendDate))
                      ? (_openBlock(), _createElementBlock("div", _hoisted_21, "有効な日付ではありません"))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("td", null, [
                    _createVNode(_component_JapaneseInput, {
                      class: "input-note",
                      modelValue: dest.note,
                      "onUpdate:modelValue": ($event: any) => ((dest.note) = $event)
                    }, null, 8, ["modelValue", "onUpdate:modelValue"])
                  ])
                ]))
              }), 128))
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_22, [
      _createElementVNode("button", {
        class: "btn-primary",
        disabled: _ctx.customerNotFound || !_ctx.newOrder.customerId,
        onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.save && _ctx.save(...args)))
      }, "保存", 8, _hoisted_23)
    ])
  ], 64))
}